// currently the format we are getting from document call is: Renteendringsbrev-xxxx.xxxxx-x-d.mm.yyyy.
// We need to extract the project name from this format. and the 'lånenummer'. this regex will handle that.
export const BANKING_INTEREST_RATE_CHANGE_DOCUMENT_REGEX = /Renteendringsbrev\s*-\s*([^\s-]+)\s*-/;